<template>
  <portal to="popup">
    <div
      v-if="isOpen"
      ref="popup"
      role="dialog"
      :aria-labelledby="`popup-heading-${uuid}`"
      :aria-describedby="`popup-content-${uuid}`"
      :class="[`popup-dialog--${type}`, { 'popup-dialog--active': isOpen }]"
      :style="{ left: `${left}px`, top: `${top}px` }"
      class="popup-dialog"
      @keydown.esc="close"
    >
      <a-focus-trap :initial-focus="`#popup-close-${uuid}`">
        <div>
          <button
            :id="`popup-close-${uuid}`"
            class="popup-dialog__close"
            @click="close"
          >
            <bpb-icon icon="i-close" label-path="popup.close"></bpb-icon>
          </button>
          <article class="popup-dialog__article">
            <slot name="figure" />
            <div class="popup-dialog__content-wrapper">
              <h2 :id="`popup-heading-${uuid}`" class="popup-dialog__heading">
                {{ heading }}
              </h2>
              <div :id="`popup-content-${uuid}`" class="popup-dialog__content">
                <slot></slot>
                <slot name="content" />
              </div>
            </div>
            <footer v-if="!!$slots.footer" class="popup-dialog__footer">
              <slot name="footer" />
            </footer>
          </article>
        </div>
      </a-focus-trap>
    </div>
  </portal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    heading: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      uuid: this.$uuid.v1(),
      left: 0,
      top: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentPopup: 'popup/current',
      windowInnerWidth: 'window/innerWidth',
    }),
    isOpen() {
      return this.id === this.currentPopup.id;
    },
    type() {
      return this.currentPopup.type;
    },
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.position();
          });
        });
      }
    },
    windowInnerWidth() {
      if (this.isOpen) this.position();
    },
  },
  methods: {
    close() {
      this.$store.dispatch('popup/update', {
        id: '',
        type: '',
        termUuid: '',
        termDimensions: undefined,
      });
    },
    position() {
      const term = this.currentPopup.termDimensions;

      const popup = this.$refs.popup;
      const popupRect = popup.getBoundingClientRect();
      const parent = this.$el.parentNode.getBoundingClientRect();

      const maxX = parent.left + window.pageXOffset + parent.width;
      const popupX = term.left + window.pageXOffset + popupRect.width;
      const corrFactor = popupX > maxX ? maxX - popupX : 0;

      this.left = `${term.left + window.pageXOffset + corrFactor}`;
      this.top = `${term.top + window.pageYOffset + term.height}`;
    },
  },
};
</script>
